import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import Cursor from './../animations/cursor';
import ButtonCtrl from './../animations/buttonCtrl';
gsap.registerPlugin(ScrollTrigger)

const
  animations = {
    marquee: async () => await import('./../animations/marquee'),
    accordions: () => import('./../animations/accordions'),
    scrollSpy: () => import('../animations/scrollspy'),
    ButtonCtrl: async () => await import('./../animations/buttonCtrl'),
    revealTextByLine: () => import('./../animations/reveal-text-by-line')
  },
  accordionsGroup = (document.querySelectorAll('.block__accordions') != null) ? document.querySelectorAll('.block__accordions') : null,
  smoothScroller = document.querySelector('.smooth-scroll'),
  textLaunch = document.querySelectorAll('.text-reveal-title'),
  smoothScrollUpdate = () => document.dispatchEvent(new Event('smoothScrollUpdate'))

  var buttons = [];
export const homepage = () => {

  //ANIMATIONS
  setTimeout(function() {
   ScrollTrigger.matchMedia({
      "(min-width: 768px) and (pointer: fine)": function () {
        $(".button:not(.no-click), .phases-trigger__btn, .institutional-trigger, #skip, .menu-go-institutional__close, .on-boarding__phases div, .menu-item,#ancore .ancora,.top-navigation__logo,.socials-share a,.socials a,.footer-t a,.move,.linkmore-a,.flickity-button, .insight__video-close > span, .testimonials__el__circle").each(function(index){
          buttons.push(new ButtonCtrl(this));
        });
    }})
  }, 100);

var timing = 1100;
 if($(".animations2").length > 0) {
  timing = 1900;
 }

 $(".donazione-libera").click(function(e){
  e.preventDefault();
  $("#donazione-libera").submit();
 })

if($(".text-reveal-title-h1").length > 0) {

  const ball_out = gsap.utils.toArray('.ball-out');
   for (const block of ball_out) {
    ScrollTrigger.create({
            scroller: smoothScroller,
            trigger: block,
            once: true,
            start: 'top 95%',
           onEnter: self =>
            gsap.to(block, {
            opacity:1,
            scale:1,
            duration:0.5
          })
    })
   }

  const animations_blocks_blur = gsap.utils.toArray('.intro-block-blur');
   for (const block of animations_blocks_blur) {
    ScrollTrigger.create({
            scroller: smoothScroller,
            trigger: block,
            once: true,
            toggleClass: 'revealed',
            start: 'top 95%',
           onEnter: self =>
            gsap.to(block, {
            opacity:1,
            delay: 0.8,
            top:0,
            toggleClass: 'visibileblur',
            duration:0.8
          })
    })
   }
} else {
  const animations_blocks_blur = gsap.utils.toArray('.intro-block-blur');
   for (const block of animations_blocks_blur) {
    ScrollTrigger.create({
            scroller: smoothScroller,
            trigger: block,
            once: true,
            toggleClass: 'revealed',
            start: 'top 95%',
           onEnter: self =>
            gsap.to(block, {
            opacity:1,
            top:0,
            toggleClass: 'visibileblur',
            duration:0.8
          })
    })
   }
}



   setTimeout(function() {
    const animations_blocks2 = gsap.utils.toArray('.animations2');
       for (const block of animations_blocks2) {
        ScrollTrigger.create({
                scroller: smoothScroller,
                trigger: block,
                once: true,
                start: 'top 95%',
               // toggleClass: 'revealed'
               onEnter: self =>  gsap.to(block, { opacity:1, top:0, duration:1.2, delay :.3})
        })
       }
   }, 900);

   setTimeout(function() {

      const borders = gsap.utils.toArray('.border-t-1,.border-b-1,.circle-lancio,.condividi-circle,.donazione-circle');
      for (const border of borders) {
       ScrollTrigger.create({
               scroller: smoothScroller,
               trigger: border,
               once: true,
               start: 'top 90%',
               toggleClass: 'revealed'
       })
      }

     const animations_blocks = gsap.utils.toArray('.animations');
       for (const block of animations_blocks) {
        ScrollTrigger.create({
                scroller: smoothScroller,
                trigger: block,
                once: true,
                start: 'top 95%',
               // toggleClass: 'revealed'
               onEnter: self =>  gsap.to(block, { opacity:1, top:0, duration:1.2, delay :.3})
        })
       }



   const tl = gsap.timeline({
      scrollTrigger: {
        scroller: smoothScroller,
        trigger: ".esperienza-circle",
        start: "top 90%",
        end: "top top",
        scrub: true
      }
    });

    tl.to(".esperienza-circle", {
      borderRadius: "50%",
      marginLeft:0,
      marginRight:0,
      width:"100%"
    });

    const tl1 = gsap.timeline({
      scrollTrigger: {
        scroller: smoothScroller,
        trigger: ".sphere",
        start: "top 90%",
        end: "+=500",
        scrub: true,
      },
      onComplete: () => smoothScrollUpdate()
    });

    tl1.to(".sphere", {
      borderRadius: "50%",
    });
 }, timing);




  //IF MARQUEE
  if($(".marquee__els-container").length > 0) {
    animations.marquee().then(module => {
      module.marquee();
    })
  }

  //IF ACCORDION
  if(accordionsGroup) {
    for (const group of accordionsGroup) {
      const accordions = group.querySelectorAll('.block__accordion')
      if (accordions.length > 0) {
        for (const [i, accordion] of accordions.entries()) {
          let isOpen = false
          const trigger = accordion.querySelector('.block__accordion__trigger'),
                container = accordion.querySelector('.block__accordion__content');
          trigger.addEventListener('click', () => {
            isOpen = !isOpen
            animations.accordions().then(module => {
              module.accordions(isOpen, container, null, null, null, null, trigger)
              accordion.classList.toggle('block__accordion--open')
            })
          })
        }
      }
    }
  }


  //ACCORDION SCHEDE
  const number_schede = $('.schede-desktop .scheda').length;
  if(number_schede) {
    var closed_width = 60/(number_schede-1);
    $(".schede-desktop .scheda").css("width",closed_width+"vw");
    $('.schede-desktop .scheda').click(function () {
      $(".schede-desktop .scheda").removeClass("active");
      $(this).addClass("active");
    });
  }


  // SCROLL ANCORE
  if($("#ancore").length > 0) {
    const desktopSubAnchorsContainer = $("#ancore")[0];
    animations.scrollSpy().then(module => module.scrollspy(desktopSubAnchorsContainer))
  }


  //TABS
  if($(".block__layout-trigger__el").length > 0) {
    $(".block__layout-trigger__bg").css("width",$(".block__layout-trigger__el button.active").outerWidth());
    $(".block__layout-trigger__el button").click(function(){
      var parent = $(this).closest(".paypal-pay");
      $(".block__layout-trigger__el button",parent).removeClass("active");
      $(this).addClass("active");
      $(".block__layout-trigger__bg",parent).css("width",$(".block__layout-trigger__el button.active",parent).outerWidth());
      $(".block__layout-trigger__bg",parent).css("left",$(".block__layout-trigger__el button.active",parent).position().left);
      $(".tab",parent).removeClass("active");
      $(".tab[data-id='"+$(this).attr("data-tab")+"']",parent).addClass("active");

    });
  }


  $(".burger,.close-icon").click(function(){
    $("html").toggleClass("menuout");
  });

  setTimeout(function() {
    ScrollTrigger.refresh()
  }, 1500);
  setTimeout(function() {
    ScrollTrigger.refresh()
  }, 3000);




  //RESET PW

  const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};


$("#paga-quote").submit(function(e){
  var send = true;
  $(".campo-obbligatorio").removeClass("campo-obbligatorio");
  $(".messaggio-show").addClass("messaggio-show");
  if(!$("input[name='os1']").val()) {
    send = false;
    $("input[name='os1']").addClass("campo-obbligatorio");
    $(".messaggio").addClass("messaggio-show");
  }
  if(!$("input[name='os2']").val()) {
    send = false;
    $("input[name='os2']").addClass("campo-obbligatorio");
    $(".messaggio").addClass("messaggio-show");
  }
  if(!$("input[name='os3']").val()) {
    send = false;
    $("input[name='os3']").addClass("campo-obbligatorio");
    $(".messaggio").addClass("messaggio-show");
  }
  if(!send) {
    e.preventDefault();
    return false;
  }
});

  $(".reset-pw-form").submit(function(e){
    e.preventDefault();
    $(".obbligo").removeClass("obbligo");
    if(!$(".reset-pw-form input[name='email']").val() || !$(".reset-pw-form input[name='email-repeat']").val() || $(".reset-pw-form input[name='email-repeat']").val() != $(".reset-pw-form input[name='email']").val() || !validateEmail($(".reset-pw-form input[name='email']").val())) {
      $(".reset-pw-form input[name='email'],.reset-pw-form input[name='email-repeat']").addClass("obbligo");
    } else {

      var email = $(".reset-pw-form input[name='email']").val();

      jQuery.ajax({
          url: ajaxurl,
          method: 'POST',
          data: {
              action: 'functions',
              function: 'reset_password_step1',
              data: {email}
          },
          success: function (response) {
            if(response=="true") {
              $("html").addClass("email-inviata");
              setTimeout(function() {ScrollTrigger.refresh()}, 10);
            } else {
              $(".utente-non-presente").removeClass("hidden");
              setTimeout(function () {
                $(".utente-non-presente").addClass("hidden");
              }, 2500);
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(errorThrown);
        },
      });
    }
    return false;
  });

   $(".reset-pw-form-step2").submit(function(e){
    e.preventDefault();
    $(".obbligo").removeClass("obbligo");
    if(!$(".reset-pw-form-step2 input[name='password']").val() || !$(".reset-pw-form-step2 input[name='password-repeat']").val() || $(".reset-pw-form-step2 input[name='password-repeat']").val() != $(".reset-pw-form-step2 input[name='password']").val() || !$(".reset-pw-form-step2 input[name='codice']").val()) {

      if(!$(".reset-pw-form-step2 input[name='password']").val() || !$(".reset-pw-form-step2 input[name='password-repeat']").val() || $(".reset-pw-form-step2 input[name='password-repeat']").val() != $(".reset-pw-form-step2 input[name='password']").val()) {
          $(".reset-pw-form-step2 input[name='password'],.reset-pw-form-step2 input[name='password-repeat']").addClass("obbligo");
      }
      if (!$(".reset-pw-form-step2 input[name='codice']").val()){
          $(".reset-pw-form-step2 input[name='codice']").addClass("obbligo");
      }
    } else {
      $("html").addClass("check-code");
      var code = $(".reset-pw-form-step2 input[name='codice']").val();
      var password = $(".reset-pw-form-step2 input[name='password']").val();
      jQuery.ajax({
          url: ajaxurl,
          method: 'POST',
          data: {
              action: 'functions',
              function: 'reset_password_step2',
              data: {code,password}
          },
          success: function (response) {
            if(response=="true") {
              $("html").addClass("password-modificata");
              ScrollTrigger.refresh()
            } else {
              $("html").removeClass("check-code");
              $(".codice-errato").removeClass("hidden");
              setTimeout(function () {
                $(".codice-errato").addClass("hidden");
              }, 2500);
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            console.log(errorThrown);
        },
      });
    }
    return false;
  });





 }
